import { render, staticRenderFns } from "./documentActionsDialog.vue?vue&type=template&id=ff97b778&scoped=true"
import script from "./documentActionsDialog.vue?vue&type=script&lang=js"
export * from "./documentActionsDialog.vue?vue&type=script&lang=js"
import style0 from "./documentActionsDialog.vue?vue&type=style&index=0&id=ff97b778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff97b778",
  null
  
)

export default component.exports